import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./TestResult.module.scss";
import StateContext from "../../context/state";
import Test from '../Test/Test';
const TestResult = () => {
  const state = useContext(StateContext);
  const {answerIndex, updatePopupOpen } = state;
  const [isFinal, setFinal] = useState(false);
  const [resultIndex, setResultIndex] = useState(0);
  const [resultValue, setResultValue] = useState(0);
  const resultData = [
    ['Полностью поддерживаю!', 'Здорово, похоже мы мыслим одинаково. Заполняйте форму — давайте превращать мысли в проекты.'],
    ['Поддерживаю, но есть сомнения.', 'Нам точно есть, что обсудить. Заполняйте форму — давайте вместе сделаем проект, который не оставит никаких сомнений.'],
    ['Много сомнений.', 'Нам точно есть, что обсудить. Заполняйте форму — давайте вместе сделаем проект, который не оставит никаких сомнений.']
  ];

  useEffect(()=>{
    const isFinal = answerIndex.filter((element)=> element !== -1).length === 4;
    const result = answerIndex.filter((element)=> element === 1).length;
    setFinal(isFinal);
    setResultValue(result);
    if(result === 4){
      setResultIndex(0);
    }else if(result > 1){
      setResultIndex(1);
    }else{
      setResultIndex(2);
    }
  },[answerIndex]);
  return (
    <>
      <div className={styles.wrap}>
        <Test>
          <>
            Готовы ли вы с нами сделать цифровой проект для системы внутренних коммуникаций вашей компании.
          </>
          <>
            {isFinal ?
              <>
              <div className={styles.result}>
                <div className={styles.result__desc}>Ваш результат:</div>
                <div className={styles.result__title}>{resultValue} из 4 — {resultData[resultIndex][0]}</div>
                <div className={styles.result__text}>{resultData[resultIndex][1]}</div>
              </div>
                <div className={styles.btns}>
                  <div className={`${styles.btn} ${styles.btn_black}`} onClick={() => updatePopupOpen(true)} >Заполнить форму</div>
                </div>
              </>
              :
              'Чтобы посмотреть результат опроса, ответьте на все сомнения в кейсе.'

            }

          </>
        </Test>
      </div>
    </>
  );

}

export default TestResult;
